import { Collapse, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { IUserFormInput, onReplaceSpecialChars } from "../../pages/UserForm";

interface IUserSelectField extends IUserFormInput {
  values: string[];
}

const UserFormSelectField = ({ label, value, mandatory, onInputChange, values }: IUserSelectField) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id={label.toLowerCase().replaceAll(" ", "-")}>{label}</InputLabel>
      <Select
        SelectDisplayProps={{ style: { whiteSpace: "normal" } }}
        label={label}
        required={mandatory}
        id={onReplaceSpecialChars(label.toLowerCase().replaceAll(" ", "-"))}
        labelId={label.toLowerCase().replaceAll(" ", "-")}
        value={value}
        onChange={(e: any) => onInputChange(e.target.value)}>
        {values.map((value: string, index: number) => (
          <MenuItem key={index} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default UserFormSelectField;
